module.exports = __webpack_public_path__ + "img/startConfigurationMemoires.c5955ff.webp";